import React from 'react'
import DeletePatientButton from './DeletePatientButton'
import { Box } from '@mui/material'
import EditProcedureButton from './EditProcedureButton'
import ViewProcedureButton from './ViewProcedureButton'
import ViewRegistryPatientActionButton from './ViewRegistryPatientActionButton'
import DeleteRegistryPatientButton from './DeleteRegistryPatientButton'
import EditRegistryPatientActionButton from './EditRegistryPatientActionButton'

interface Props {
  id: number;
  refetch?: () => void;
}

export default function RegistryPatientActionButtons({ id, refetch }: Props) {
  return (
    <Box
      display={'flex'}
      gap={1}
    >
      <ViewRegistryPatientActionButton id={id} refetch={refetch} />
      <EditRegistryPatientActionButton id={id} refetch={refetch} />
      <DeleteRegistryPatientButton id={id} refetch={refetch} />
    </Box>
  )
}
